import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { assertTrue } from 'src/app/utils/assert.util';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  private router = inject(Router);
  private trackingID?: string;

  get isInitialized(): boolean {
    return !!this.trackingID && !!(window as any).gtag;
  }

  public init(trackingID: string) {
    this.trackingID = trackingID;

    this.onRouteChange();

    try {
      const gTagScript = document.createElement('script');
      gTagScript.async = true;
      gTagScript.src = `https://www.googletagmanager.com/gtag/js?id=${trackingID}`;
      document.head.appendChild(gTagScript);

      const dataLayerScript = document.createElement('script');
      dataLayerScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${trackingID}', {'send_page_view': false});`;
      document.head.appendChild(dataLayerScript);
    } catch (e) {
      console.error('Error adding Google Analytics', e);
    }
  }

  private onRouteChange() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        (window as any).gtag('config', this.trackingID, {
          page_path: event.urlAfterRedirects,
        });
      }
    });
  }

  public triggerEvent(action: string, eventCategory?: string, eventLabel?: string, value?: string) {
    assertTrue(this.isInitialized, 'No ga tracking id. Did you init?');
    (window as any).gtag('event', action, {
      ...(eventCategory && { event_category: eventCategory }),
      ...(eventLabel && { event_label: eventLabel }),
      ...(value && { value: value }),
    });
  }
}
